<template>
<div >
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="addItem()" round >ADD CATEGORY</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD CATEGORY</h1>
        <v-spacer></v-spacer>
        <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 md12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="*Category Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="editedItem.abbreviation"
                    label="*Category Abbreviation"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                 <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="packageCatTypes"
                    v-model="editedItem.packageCatType"
                    label="*Category Type"
                    required
                    persistent-hint
                  > </v-autocomplete>
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field
                    text-transform: uppercase
                    v-model="editedItem.code"
                    label="*Category Code"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field
                    v-model="editedItem.description"
                    label="Description"
                    persistent-hint
                  ></v-text-field>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center row>
            <v-btn v-if="editedItem.name&&editedItem.abbreviation&&editedItem.packageCatType&&editedItem.code" color="primary" class="white--text" round @click="saveNew">Save</v-btn>
            <v-btn v-else disabled round>Save</v-btn>
            </v-layout>
            
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -------------------------------------------------------------------------------------------->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
       
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT CATEGORY</h1>
        <v-spacer></v-spacer>
        <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
            
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="*Category Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12 md12>
                  <v-text-field
                    v-model="editedItem.abbreviation"
                    label="*Category Abbreviation"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="packageCatTypes"
                    v-model="editedItem.packageCatType"
                    label="*Category Type"
                    required
                    persistent-hint
                  > </v-autocomplete>
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field
                    v-model="editedItem.code"
                    label="*Category Code"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field
                    v-model="editedItem.description"
                    label="Desription"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
     
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
             <v-layout justify-center row>
              <!-- <v-btn color="primary" class="white--text" round @click="close">Cancel</v-btn> -->
             <v-btn v-if="editedItem.name&&editedItem.abbreviation&&editedItem.packageCatType&&editedItem.code" color="primary" class="white--text" round @click="save">Save</v-btn>
            <v-btn v-else disabled round>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="packagesFnoCats"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center">{{props.item.abbreviation}}</td>
          <td class="text-xs-center">{{props.item.packageCatType}}</td>
          <td class="text-xs-center">{{props.item.code}}</td>
          <td class="text-xs-center">{{props.item.description}}</td>
          <td class="text-xs-center" v-if="props.item.isActive">
          <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
          </td>

          

          
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->

    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    packageCatTypes: ['Residential', 'Business','Other'],
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Abbreviation",
        align: "center",
        value: "abbreviation"
      },
      {
        text: "Package Type",
        align: "center",
        value: "packageCatType"
      },
      {
        text: "Code",
        align: "center",
        value: "code"
      },
      {
        text: "Description",
        align: "center",
        value: "description"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
    ],
    packagesFnoCats: [],
    editedIndex: -1,
    editedItem: {
        name: "",
        packageCatType:"",
        code: "",
        description: "",
        isActive: true,
        isDeleted: false
    },
    defaultItem: {
        name: "",
        packageCatType:"",
        code: "",
        description: "",
        isActive: true,
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.packagesFnoCats= await this.searchPackagesFnoCats(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  created() {
    this.initialize();
  },
  methods: {
     searchPackagesFnoCats(search){
       this.isloading=true
      if(search.search!==""){      
        Api()
        .get('/packagesFnoCats',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.packagesFnoCats=response.data
           this.isloading=false
        })} 
      },
    fetchPackagesFnoCats() {
      this.isloading=true
      Api()
        .get("/packagesFnoCats/active")
        .then(response => {
          this.packagesFnoCats = response.data;
          this.isloading=false
        });
      
    },
    initialize() {
      this.fetchPackagesFnoCats();
    },
    addItem(){
if(this.authCreate(this.$store.state.currentRoute)){
this.newDialog=true
}
    },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedIndex = this.packagesFnoCats.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      }
    },
    deleteItem(id) {
      if(this.authDelete(this.$store.state.currentRoute)){
         confirm("Are you sure you want to delete this item?") &&
      Api().put("/packagesFnoCats/" + id, {
          isActive: false,
          isDeleted: true
        }).then(response => {
        this.fetchPackagesFnoCats();
        })
      }
     
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
       let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
        if (this.editedItem.packageCatType == "") {
        proceed = false;
        confirm("Please select a package category type.");
      }
        if (this.editedItem.code == "") {
        proceed = false;
        confirm("Please fill in a code.");
      }
      if (proceed == true) {
        Api().put("/packagesFnoCats/" + this.editedItem.id, {
          name: this.editedItem.name,
          abbreviation: this.editedItem.abbreviation,
          packageCatType: this.editedItem.packageCatType,
           code: this.editedItem.code,
          description: this.editedItem.description,
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive
        }).then(response => {
        this.fetchPackagesFnoCats();
        })
        this.close();
        Object.assign(this.packagesFnoCats[this.editedIndex], this.editedItem);
      }
      },
      saveNew() {
        let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
        if (this.editedItem.packageCatType == "") {
        proceed = false;
        confirm("Please select a package category type.");
      }
        if (this.editedItem.code == "") {
        proceed = false;
        confirm("Please fill in a code.");
      }
      if (proceed == true) {
        Api().post("/packagesFnoCats", {
          name: this.editedItem.name,
          abbreviation: this.editedItem.abbreviation,
          packageCatType: this.editedItem.packageCatType,
           code: this.editedItem.code,
          description: this.editedItem.description,
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive     
        }).then(response => {
        this.fetchPackagesFnoCats();
        })
        this.close();
    }
      }
  }
};
</script>
